import React, {Component} from 'react';

import _ from "lodash";
import swal from 'sweetalert2';
import axios from "axios/index";

import urls from "../../../../utils/urls";
import {tokenHeader} from "../../../../utils/headers";
import translator from "../../../../utils/translations";
import {ajaxHandler} from "../../../../utils/errors";
import {Spinner} from "../../../../components/Loading/Spinner";

export default class TerminalForm extends Component {

    constructor(props) {
        super(props);

        let activeState = {
            id: null,
            code: '',
            terminal: '',
            name: ''
        };

        if (this.props.item) {
            let island = this.props.item;
            activeState = {
                id: island.id,
                name: island.name,
                terminal: `${island.terminal.id}`,
                code: island.code
            };
        }

        this.state = {
            ...activeState,
            ajaxInProgress: false,
            terminals: false
        };
    }

    componentDidMount(){
        this._fetchOptions();
    }

    _initializeHTML = () => {
        window.initializeSelects('.admin-modal');
        window.bindSelectAction(this.terminalSelect, this._handleSelectChange);
    };

    _fetchOptions = () => {
        const TERMINAL_URL = `${urls.API_ROOT}/api/v1/terminal/`;
        axios.get(TERMINAL_URL, tokenHeader())
            .then(response => {
                this.setState({
                    terminals: response.data
                }, this._initializeHTML);
            })
            .catch(ajaxHandler);
    };

    _handleInput = (prop, value) => {
        this.setState({[prop]: value});
    };

    _handleToggle = (prop, value) => {
        this.setState({[prop]: value});
    };

    _handleSelectChange = (ev) => {
        let target = ev.target;
        let prop = target.getAttribute('data-state-var');
        this.setState({[prop]: target.value});
    };

    _submitForm = () => {

        this.setState({ajaxInProgress: true});

        let excludedKeys = ['ajaxInProgress', 'id', 'terminals'];

        let data = _.omit(this.state, excludedKeys);
        Object.keys(data).forEach(key => {if (data[key] === ''){data[key] = null;}});

        if(this.state.id){
            const UPDATE_TERMINAL = `${urls.API_ROOT}/api/v1/loadingislands/id/${this.state.id}/`;
            axios.put(`${UPDATE_TERMINAL}`, data, tokenHeader())
                .then(this._onSubmitSuccess)
                .catch(this._onSubmitError);
        }else{
            const NEW_TERMINAL = `${urls.API_ROOT}/api/v1/loadingislands/`;
            axios.post(`${NEW_TERMINAL}`, data, tokenHeader())
                .then(this._onSubmitSuccess)
                .catch(this._onSubmitError);
        }
    };

    _onSubmitSuccess = () => {
        this.setState({ajaxInProgress: false});

        swal({
            title: `Depósito ${this.state.id ? 'actualizado' : 'creado'}`,
            html: 'La información ingresada ha sigo guardada correctamente',
            type: 'success',
            showConfirmButton: false,
            timer: 2000
        });

        this.props.closeAction();
        this.props.refreshAction();
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido guardar la información del depósito',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };

    render() {

        if(!this.state.terminals){
            return (
                <div className={"admin-modal"}>
                    <Spinner />
                </div>
            );
        }

        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>{this.state.id ? 'Edición de Isla de Descarga' : 'Alta de Isla de Descarga'}</h3>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <input placeholder={"Ingrese un valor"} value={this.state.name} type={"text"}
                               onChange={(ev) => this._handleInput('name', ev.target.value)}
                        />
                        <label className="active">Nombre</label>
                    </div>
                    <div className={"col s12 input-field"}>
                        <input placeholder={"Ingrese un valor"} value={this.state.code} type={"text"}
                               onChange={(ev) => this._handleInput('code', ev.target.value)}
                        />
                        <label className="active">Código</label>
                    </div>
                    <div className={'col s12 input-field'}>
                        <select defaultValue={this.state.terminal} data-state-var="terminal"
                                ref={ref => {this.terminalSelect = ref}}>
                            <option className="select-option" value="">Seleccione una opción</option>
                            {this.state.terminals && this.state.terminals.map(terminal => {
                                return <option key={terminal.id} id={terminal.id}
                                               value={terminal.id}>{terminal.name}</option>
                            })}
                        </select>
                        <label>Terminal</label>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={`btn btn-shell-empty z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={`btn btn-shell z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this._submitForm}
                        >Guardar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/IslandForm.js